/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React, { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { Button, Text, Icon } from '../../index'
import BurgerMenu from './BurgerMenu'
import Logo from '../../../svg/Logo'
import Menu from '../../../svg/Menu'
import logoImg from 'url:../../../../img/Logo_eggs_connect.webp'
import { useUser } from '../../../hooks/useUser'

function Header({ auth, signOutRedirect }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()
  const isHomePage = location.pathname === '/'
  const { isLoggedIn } = useUser()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <>
      <div className="p-4 pb-0 w-full flex justify-between items-center">
        <div>
          <NavLink to="/" aria-label="Startseite">
            <img src={logoImg} alt="eggs connect" className="h-48 w-auto shrink-0" width="265" height="120" />
          </NavLink>
        </div>

        <div className="flex items-center space-x-3">
          {isLoggedIn && (
            <Icon name="user" size={24} color="#F5C518" />
          )}

          <Button
            variant={isMenuOpen ? "brand" : "secondary"}
            size="md"
            onClick={toggleMenu}
            className="transition-all duration-300 transform hover:scale-105"
            hasLeadingIcon={true}
            leadingIcon="menu"
          >
            <span className="sr-only">Menü öffnen</span>
          </Button>
        </div>
      </div>

      <BurgerMenu
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        auth={auth}
        signOutRedirect={signOutRedirect}
      />
    </>
  )
}

export default Header
